import React, { useContext, useEffect, useMemo, useState } from "react";
import { DContext } from "../../context/Datacontext";
import { fetchAProfileActionHistory } from "../services/fetchGetUser";

export const ProfileActionHistory = () => {
    const { BeURL, showAlert } = useContext(DContext);

    const [profileActionHistory, setProfileActionHistory] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const [showPopup, setShowPopup] = useState(false);
    const [showStatusPopup, setShowStatusPopup] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");

    const itemsPerPage = 20;

    useEffect(() => {
        fetchAProfileActionHistory(BeURL, showAlert, setProfileActionHistory);
    }, [BeURL, showAlert]);

    //SEARCH FILTER
    const filteredData = useMemo(() => {
        return profileActionHistory.filter((item) => {
            const name = item?.candidate?.name?.toLowerCase() || "";
            const email = item?.candidate?.email?.toLowerCase() || "";
            const search = searchTerm.toLowerCase();

            return name.includes(search) || email.includes(search);
        });
    }, [profileActionHistory, searchTerm]);

    //PAGINATION
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const currentData = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return filteredData.slice(start, start + itemsPerPage);
    }, [filteredData, currentPage]);

    // ===== POPUPS =====
    const openPopup = (item) => {
        setSelectedRecord(item);
        setShowPopup(true);
    };

    const closePopup = () => {
        setShowPopup(false);
        setSelectedRecord(null);
    };

    const openStatusPopup = (item) => {
        setSelectedRecord(item);
        setShowStatusPopup(true);
    };

    const closeStatusPopup = () => {
        setShowStatusPopup(false);
        setSelectedRecord(null);
    };

    const formatDate = (date) => {
        if (!date) return "-";
        return new Date(date).toLocaleString();
    };

    return (
        <div className="p-4 md:p-6">

            {/* HEADER + SEARCH */}
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold">Profile Action History</h2>

                <input
                    type="text"
                    placeholder="Search by name or email..."
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                    className="border px-3 py-2 rounded-lg text-sm w-64"
                />
            </div>

            {/* TABLE */}
            <div className="bg-white rounded-xl shadow p-4">
                <div className="overflow-x-auto">
                    <table className="min-w-full border rounded-lg">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-4 py-2">#</th>
                                <th className="px-4 py-2">Candidate</th>
                                <th className="px-4 py-2">Job</th>
                                <th className="px-4 py-2">Company</th>
                                <th className="px-4 py-2">Action Count</th>
                                <th className="px-4 py-2">Created</th>
                                <th className="px-4 py-2">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((item, index) => (
                                    <tr key={item._id} className="border-t">
                                        <td className="px-4 py-2">
                                            {(currentPage - 1) * itemsPerPage + index + 1}
                                        </td>

                                        <td className="px-4 py-2">
                                            <div>{item?.candidate?.name}</div>
                                            <div className="text-xs text-gray-500">
                                                {item?.candidate?.email}
                                            </div>
                                        </td>

                                        <td className="px-4 py-2">{item?.job?.title}</td>
                                        <td className="px-4 py-2">{item?.company?.name}</td>

                                        <td className="px-4 py-2">
                                            {item?.actionHistory?.length || 0}
                                        </td>

                                        <td className="px-4 py-2">
                                            {formatDate(item?.createdAt)}
                                        </td>

                                        <td className="px-4 py-2 flex gap-2">
                                            <button
                                                onClick={() => openPopup(item)}
                                                className="px-2 py-1 bg-blue-600 text-white rounded"
                                            >
                                                Action
                                            </button>

                                            <button
                                                onClick={() => openStatusPopup(item)}
                                                className="px-2 py-1 bg-green-600 text-white rounded"
                                            >
                                                Submission
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center py-4">
                                        No results found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* PAGINATION */}
                <div className="flex justify-between mt-4">
                    <button
                        onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                        disabled={currentPage === 1}
                        className="px-3 py-1 border"
                    >
                        Prev
                    </button>

                    <span>Page {currentPage} / {totalPages || 1}</span>

                    <button
                        onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                        disabled={currentPage === totalPages || totalPages === 0}
                        className="px-3 py-1 border"
                    >
                        Next
                    </button>
                </div>
            </div>

            {/* ACTION POPUP */}
            {showPopup && selectedRecord && (
                <div className="fixed inset-0 bg-black/50 flex justify-center items-center">
                    <div className="bg-white p-6 rounded w-[800px] max-h-[80vh] overflow-auto">
                        <h3 className="text-lg font-bold mb-4">Action History</h3>

                        <table className="min-w-full border">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>User</th>
                                    <th>Type</th>
                                    <th>Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedRecord.actionHistory.map((a, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{a?.user?.name}</td>
                                        <td>{a?.type}</td>
                                        <td>{formatDate(a?.timestamp)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <button onClick={closePopup} className="mt-4 bg-gray-800 text-white px-3 py-1">
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* SUBMISSION POPUP */}
            {showStatusPopup && selectedRecord && (
                <div className="fixed inset-0 bg-black/50 flex justify-center items-center">
                    <div className="bg-white p-6 rounded w-[900px] max-h-[80vh] overflow-auto">
                        <h3 className="text-lg font-bold mb-4">Submission History</h3>

                        <table className="min-w-full border">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>User</th>
                                    <th>Status</th>
                                    <th>Note</th>
                                    <th>Schedule</th>
                                    <th>Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedRecord.statusHistory.map((s, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{s?.user?.name}</td>
                                        <td>{s?.status?.statusLabel}</td>
                                        <td>{s?.note || "-"}</td>
                                        <td>{formatDate(s?.scheduledDate)}</td>
                                        <td>{formatDate(s?.timestamp)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <button onClick={closeStatusPopup} className="mt-4 bg-gray-800 text-white px-3 py-1">
                            Close
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
};